import React from "react";
import Restpassword from "../components/resetpassword";
export function ResetpasswordPage() {
  return (
    <div>
      <Restpassword />
    </div>
  );
}
export default ResetpasswordPage;
